import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';

interface GameLayoutProps {
  children: ReactNode;
  online?: number;
}

export function GameLayout({ children, online }: GameLayoutProps) {
  return (
    <>
      <Header online={online} />
      <main className="container" style={{ paddingTop: 40, paddingBottom: 64, minHeight: '70vh' }}>
        <Link to="/" className="label" style={{ textDecoration: 'none', display: 'inline-block', marginBottom: 24 }}>
          ← На главную
        </Link>
        {children}
      </main>
      <footer className="foot">
        <div className="container">
          <div className="foot-row">
            <span>© Шум.клуб · MMXXVI · всё разрешено, кроме скуки</span>
            <span>Mafia Live · MVP</span>
          </div>
        </div>
      </footer>
    </>
  );
}
